<div
  [class.mustang]="mustang"
  [class.register-custom-ui]="registerCustomUI?.backgroundImage"
  [class.c-white]="mustang || registerCustomUI?.backgroundImage"
  [ngStyle]="{ 'background-image': registerCustomUI?.backgroundImage ? 'url(' + registerCustomUI?.backgroundImage + ')' : '' }"
  cdkTrapFocus
>
  @if (!mustang && !registerCustomUI) {
    <div class="modal-header">
      <h1 id="modal-title" class="modal-title">{{ "products.register.register_my_gear" | translate }}</h1>
      @if (!registering) {
        <button
          type="button"
          ngbAutofocus
          class="fs-close-btn right border-0 bg-transparent p-0"
          (click)="activeModal.dismiss(dismissMessage)"
          data-cy="close-success-splash-button"
          aria-label="close"
        >
          <fa-icon icon="times-circle" class="circle-icon-btn" aria-hidden="true"></fa-icon>
        </button>
      }
    </div>
  }
  <div class="modal-body">
    @if (foundFenderGear) {
      <div class="m-y-30">
        <hr />
        @if (foundFenderGear.length == 1) {
          <span>{{ "products.register.missing_fender_serial.found_serial_message" | translate }}</span>
        } @else if (foundFenderGear.length > 1) {
          <span>{{ "products.register.missing_fender_serial.found_serial_message_multiple" | translate }}</span>
        }
        <br />
        <br />
        @for (gear of foundFenderGear; track gear) {
          <div class="d-flex m-y-20 align-items-center">
            @if (gear.product.imageUrl) {
              <img [src]="gear.product.imageUrl" class="m-r-20" style="max-width: 200px; max-height: 200px" />
            }
            <div>
              <span class="fui-heading-font t-20">{{ gear.product.title }}</span>
              <br />
              <br />
              <button class="btn btn-primary btn-sm" type="button" [disabled]="saving" (click)="finalizeFenderRegister(gear)">
                {{ "products.register.missing_fender_serial.add_to_account" | translate }}
                @if (saving) {
                  <fa-icon icon="spinner" class="m-l-10" [animation]="'spin'"></fa-icon>
                }
              </button>
            </div>
          </div>
        }
        <button class="btn btn-blank btn-sm" type="button" [disabled]="saving" (click)="foundFenderGear = undefined; registering = false">
          {{ "products.register.missing_fender_serial.not_my_gear" | translate }}
        </button>
        <hr />
      </div>
    }
    @if (!foundFenderGear) {
      @if (mustang) {
        <div class="text-center m-b-20">
          <img src="./assets/images/mustangmicro-logo-white.svg" alt="Mustang Micro" style="max-width: 250px; margin: auto" />
        </div>
      }
      @if (registerCustomUI?.headerImage) {
        <div class="text-center m-b-20 m-t-20">
          <img [src]="registerCustomUI.headerImage" style="max-width: 300px; margin: auto" />
        </div>
      }
      @if (registering) {
        <div class="modal-loader m-y-20 text-center" role="status" aria-live="assertive">
          <myp-inline-loader [loading]="registering" height="100px" spinnerName="registeringProductLoader" aria-hidden="true"></myp-inline-loader>
          <span>{{ loadingProgressMessage }}</span>
          <br />
          <br />
          <span class="t-12">{{ "products.register.do_not_go_back" | translate }}</span>
        </div>
      }
      @if (!registering && !registerResponse) {
        <div class="form-group">
          @if (optionCardOptions && optionCardOptions.asset_ids.length > 1) {
            <div>
              {{ "product_detail.option_cards.choose_opt_card_asset" | translate }}
              <select class="form-control" [(ngModel)]="selectedOptionCardAssetId">
                @for (opt of optionCardOptions.asset_ids; track opt) {
                  <option [value]="opt.asset_id">{{ opt.serial }}</option>
                }
              </select>
            </div>
          }
          @if (mustang) {
            <div>{{ "products.register.mustang_instructions" | translate }}</div>
          }
          @if (registerCustomUI?.blurb) {
            <div>{{ registerCustomUI.blurb }}</div>
          }
          @if (!mustang && !registerCustomUI?.hardwareOnly && !optionCardOptions) {
            <div>
              <label id="modal_label" class="control-label mb-0">{{ "products.register.what_type_register_gear" | translate }}</label>
              <div class="register-product-options">
                <div class="register-product-option" tabindex="0" [class.selected]="selectedType == 'guitar'" mode="button" (click)="selectedType = 'guitar'">
                  <img src="./assets/images/register-fender-gear.png" alt="Guitar" />
                  <span>{{ "general.fender_gear" | translate }}</span>
                </div>
                <div class="register-product-option" tabindex="0" [class.selected]="selectedType == 'software'" mode="button" (click)="selectedType = 'software'">
                  <img src="./assets/images/register-software.png" alt="Software" />
                  <span>{{ "general.software" | translate }}</span>
                </div>
                <div class="register-product-option" tabindex="0" [class.selected]="selectedType == 'hardware'" mode="button" (click)="selectedType = 'hardware'">
                  <img src="./assets/images/register-presonus-hardware.png" alt="Hardware" />
                  <span>{{ "general.recording_hardware" | translate }}</span>
                </div>
              </div>
            </div>
          }
          <br />
          @if (selectedType == "software") {
            <fieldset>
              <legend class="control-label" for="productkey">
                <label for="productkey" class="control-label">
                  {{ "products.register.enter_your_key" | translate }}
                  <sup><code>*</code></sup>
                </label>
              </legend>
              <input
                id="productkey"
                ngbAutofocus
                class="form-control mono text-md"
                (keydown)="keyPressed($event)"
                guide="false"
                [maskito]="{ mask: mask }"
                [(ngModel)]="productKey"
                [placeholder]="'products.register.enter_key_placeholder' | translate"
                aria-describedby="key_length_instructions"
                required
              />
              <!-- <small class="pad text-muted" id="key_length_instructions">{{ "products.register.key_length_desc" | translate }}</small> -->
              <br />
            </fieldset>
          } @else if (selectedType == "hardware" || selectedType == "guitar") {
            <div>
              @if (!mustang) {
                <fieldset class="form-group">
                  <legend>
                    <strong>
                      <label class="control-label" for="hw_purchase_date">
                        {{ "products.register.enter_purchase_date" | translate }}
                        <sup><code>*</code></sup>
                      </label>
                    </strong>
                  </legend>
                  <button
                    class="form-control pointer select-date-button"
                    [class.register-custom-ui-input]="registerCustomUI?.backgroundImage"
                    [class.c-white]="registerCustomUI?.backgroundImage"
                    name="hw_purchase_date"
                    id="hw_purchase_date"
                    (click)="showDatePicker()"
                  >
                    {{ date ? (date | date) : ("newdash.choose_date" | translate) }}
                  </button>
                </fieldset>
              }
              <fieldset class="form-group">
                <legend>
                  <strong>
                    <label class="control-label" for="hw_serial_number">
                      {{ "products.register.enter_your_serial_number" | translate }}
                      <sup><code>*</code></sup>
                    </label>
                  </strong>
                </legend>
                <input
                  type="text"
                  data-cy="serial-number-input"
                  [(ngModel)]="productKey"
                  (keydown)="keyPressed($event)"
                  [placeholder]="(selectedType == 'guitar' ? 'products.register.enter_serial_fender_placeholder' : 'products.register.enter_serial_number_placeholder') | translate"
                  class="form-control mono text-md"
                  [class.mustang-input]="mustang"
                  [class.register-custom-ui-input]="registerCustomUI?.backgroundImage"
                  placeholder=""
                  id="hw_serial_number"
                  required
                />
              </fieldset>
              @if (selectedType == "guitar") {
                <div class="m-t-10">
                  <small class="pad text-muted bold">{{ "products.register.where_find_sn" | translate }}</small>
                  <br />
                  <small class="pad text-muted" id="key_length_instructions" [innerHTML]="'products.register.fender_gear_serial_location' | translate"></small>
                </div>
              } @else {
                @if (hasUsbAccess) {
                  <div class="m-t-10">
                    <small class="pad text-muted bold">{{ "products.register.usb_device_header" | translate }}</small>
                    <br />
                    <small class="pad text-muted" [innerHTML]="'newdash.detect_connected_device' | translate"></small>
                    <br />
                    <br />
                    <button class="btn btn-secondary btn-sm" (click)="detectSerial()">{{ "newdash.detect_serial" | translate }}</button>
                  </div>
                }
                <div class="m-t-10">
                  <small class="pad text-muted bold">{{ "products.register.where_find_sn" | translate }}</small>
                  <br />
                  <small class="pad text-muted" id="key_length_instructions" [innerHTML]="'products.register.hw_where_find' | translate"></small>
                </div>
              }
            </div>
          }
          @if (errorMsg) {
            <div class="d-flex align-items-center error-container m-t-20">
              <fa-icon icon="exclamation-triangle"></fa-icon>
              <div class="error-box" [innerHTML]="errorMsg"></div>
            </div>
          }
        </div>
      }
      @if (!registering && registerResponse) {
        <div class="text-center">
          <fa-icon icon="check-circle" class="c-green" style="font-size: 35px"></fa-icon>
          <br />
          <br />
          {{ optionCardOptions ? ("products.register.optioncard_success" | translate) : ("products.register.product_success" | translate) }}
          <br />
          <br />
          @if (registeredProduct && registeredProduct.navId == "ABOX96KULTIMATE") {
            <div>
              {{ "products.register.eris_dontforget" | translate }}
              <br />
              <br />
              <button class="btn btn-primary" (click)="resetRegisterFlow('hardware')">{{ "products.register.register_eris" | translate }}</button>
              <br />
              <br />
            </div>
          }
          @if (registeredProduct && registeredProduct.navId == "ATOMPRODUCERSLAB") {
            <div>
              {{ "products.register.atom_dontforget" | translate }}
              <br />
              <br />
              <button class="btn btn-primary" (click)="resetRegisterFlow('hardware')">{{ "products.register.register_atom" | translate }}</button>
              <br />
              <br />
            </div>
          }
          @if (registeredProduct && registeredProduct.navId == "FADERPORT8") {
            <div>
              {{ "products.register.faderport_new_firmware" | translate }}
              <br />
              <br />
              <a class="btn btn-primary" href="http://www.presonus.com/products/FaderPort-8/downloads" target="_blank">{{ "products.register.download_uc" | translate }}</a>
              <br />
              <br />
            </div>
          }
          @if (rewards && rewards.length == 1) {
            <div>
              <span [translate]="'products.register.register_reward'" [translateParams]="{ rewardTitle: registerResponse.reward.title }"></span>
              <br />
            </div>
          }
          @if (rewards && rewards.length > 1) {
            <div>
              <span>{{ "sphere.congrats_promo_product" | translate }}</span>
              <br />
              <br />
              @for (reward of rewards; track reward) {
                <div>
                  <strong>{{ reward.title }}</strong>
                </div>
              }
            </div>
          }
          @if (!optionCardOptions) {
            <button type="button" class="btn btn-primary" (click)="viewRegisteredProduct(registerResponse.assetId || registerResponse.licenseId)">
              {{ "general.view_product" | translate }}
            </button>
          }
          @if (optionCardOptions) {
            <button type="button" class="btn btn-primary" [class.c-white]="mustang || registerCustomUI?.backgroundImage" (click)="activeModal.close()">
              {{ "general.close" | translate }}
            </button>
          }
        </div>
      }
    }
  </div>
  @if (!registering && !registerResponse && !foundFenderGear) {
    <div class="modal-footer" ngbAutofocus>
      <button type="button" class="btn btn-primary" data-cy="register-button" (click)="performRegister()">
        {{ (upgrading ? "product_detail.upgrade.upgrade" : mustang ? "Redeem" : "products.register.register") | translate }}
      </button>
      <button type="button" class="btn btn-blank" [class.c-white]="mustang || registerCustomUI?.backgroundImage" (keydown)="$event.stopPropagation()" (click)="close($event)">
        {{ "general.close" | translate }}
      </button>
    </div>
  }

  <ng-template #popContent>
    {{ "products.register.sn_location_desc" | translate }}
  </ng-template>
  <ng-template #popTitle>
    <span style="color: #333">{{ "products.register.where_find_sn" | translate }}</span>
  </ng-template>
</div>
